/**
 * Utility to derive the surface from the current route.
 * Used for global metadata injection in Statsig events.
 *
 * No "use client" directive - pure function usable on both client and server.
 */

export type Surface =
  | "home"
  | "list"
  | "paywall"
  | "checkout"
  | "visit"
  | "chat"
  | "widget"
  | "error"
  | "other";

export function deriveSurface(route: string): Surface {
  const segment = route.replace(/^\//, "").split("/")[0] || "";

  switch (segment) {
    // Direct: segment matches surface name
    case "list":
    case "paywall":
    case "chat":
    case "error":
    case "visit":
      return segment;

    case "":
    case "home":
      return "home";

    case "home-checkout":
    case "register":
      return "checkout";

    case "select-patient":
    case "intake":
      return "visit";

    case "dismissable-cta":
    case "triaged-cta":
    case "value-props":
      return "widget";

    default:
      return "other";
  }
}
